const { Provider } = require('react-redux');
const { wrapHOC, wrapHOCComponent } = require('utils/framework');
const React = require('react');
const store = require('Store');

const withReduxProvider = wrapHOC(function withReduxProvider(WrappedComponent) {
    const ReduxProvider = props => (
        <Provider store={store}>
            <WrappedComponent {...props} />
        </Provider>
    );

    return wrapHOCComponent(ReduxProvider, 'ReduxProvider', arguments);
});

module.exports = { withReduxProvider };
